<template>
  <Section
    @back="$emit('back')"
    title="新聞購読率条件設定"
    margin
    tip-message="新聞購読率条件設定に戻る"
  >
    <template>
      <v-subheader>新聞購読率</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.subscriptionRate }}%{{ conditions }}
        </v-flex>
      </v-layout>
    </template>
    <CampaignModalPageConfirmArea :menuSetting="menuSetting" />
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
import CampaignModalPageConfirmArea from './CampaignModalPageConfirmArea'

export default {
  name: 'CampaignModalPageConfirmNewspaperTarget',
  components: {
    Section,
    CampaignModalPageConfirmArea,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    conditions() {
      if (this.menuSetting.conditions === 'greater') {
        return '以上'
      } else {
        return '以下'
      }
    },
  },
}
</script>
